import '../style.scss'
import { useRef } from "react";
import { RiCloseFill } from "react-icons/ri"
import { SidePopupContainer, FlexColumn, AppSpan, Button, FlexRow, CustomContainer, AppText, Form, FormGroup, AppLabel } from "src/style"
import utility from "src/utils/utility"
import helpers from 'src/utils/helpers';
import MasterCardIcon from 'src/assets/img/mastercard-icon.svg'

export const CardDetails: React.FC<any> = ({fundingInput, setFundingInput, next, close}) => {

    const expiryMonthRef = useRef<any>(null);
    const expiryYearRef = useRef<any>(null);
    
    const handleAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
        let val = e.target.value.replace(/[,.]/g, '')
        if (!isNaN(Number(val))) {
            setFundingInput({...fundingInput, amount: val})
        }
    }

    function handleExpiryInput (e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.name === 'expiryMonth') {
            if (e.target.value.length >= 2) expiryYearRef.current.focus(); 
            if (e.target.value.length > 2) return false;
        }
        
        if (e.target.name === 'expiryYear') {
            if (e.target.value.length > 4) return false
            if (e.target.value.length === 0) expiryMonthRef.current.focus()
        }

        setFundingInput({...fundingInput, [e.target.name]: e.target.value})
    }

    function handleCardNumber (e: React.ChangeEvent<HTMLInputElement>) {
        let val = e.target.value
        if (val.length > 19) return false
        else {
            val = helpers.formatCardNumber(val)
        }

        setFundingInput({...fundingInput, cardNumber: val})
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Pay with Card</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#667085'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <CustomContainer topMargin="2">
                    <AppText textSize="1.6" color="#101828" fontWeight="300">
                        Kindly enter amount and card details
                    </AppText>
                    <Form topMargin="2" onSubmit={next}>
                        <FormGroup>
                            <label>Amount</label>
                            <input 
                                placeholder='Enter Amount' 
                                name='amount'
                                autoComplete='off'
                                value={fundingInput.amount ? utility.koboFormat(fundingInput.amount) : ''}
                                onChange={handleAmount}
                                required
                            />
                        </FormGroup>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='card-input-row-container'
                        >
                            <FormGroup 
                                bottomMargin='0' width="67"
                                className="card_card-name"
                            >
                                <label>Name on Card</label>
                                <input 
                                    placeholder="Enter card name"
                                    name='nameOnCard'
                                    value={fundingInput.nameOnCard}
                                    onChange={(e) => setFundingInput({...fundingInput, nameOnCard: e.target.value})}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <CustomContainer 
                                width="30" sizeUnit="%"
                                className="card_expiry-details"
                            >
                                <AppLabel fontWeight="500" bottomMargin="0.5" color="#344054">Expiry</AppLabel>
                                <FlexRow 
                                    gap='0.5' padding="1" 
                                    borderColor="#D0D5DD"
                                    radius="0.8" height="4.4"
                                >
                                    <input 
                                        placeholder="MM"
                                        name='expiryMonth'
                                        value={fundingInput.expiryMonth}
                                        onChange={handleExpiryInput}
                                        autoComplete="off"
                                        required
                                        className="card-expiry-month"
                                        ref={expiryMonthRef}
                                    />
                                    <AppSpan fontWeight="300" textSize="1.6" color="#D0D5DD">/</AppSpan>
                                    <input 
                                        placeholder="YYYY"
                                        name='expiryYear'
                                        value={fundingInput.expiryYear}
                                        onChange={handleExpiryInput}
                                        autoComplete="off"
                                        required
                                        className="card-expiry-year"
                                        ref={expiryYearRef}
                                    />
                                </FlexRow>
                            </CustomContainer>
                        </FlexRow>

                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='card-input-row-container'
                        >
                            <CustomContainer 
                                width="67" sizeUnit="%"
                                className="card_card-name"
                            >
                                <AppLabel fontWeight="500" bottomMargin="0.5" color="#344054">Card number</AppLabel>
                                <FlexRow 
                                    gap='1' padding="1" 
                                    borderColor="#D0D5DD"
                                    radius="0.8" height="4.4"
                                >
                                    { helpers.isMastercard(fundingInput.cardNumber) &&
                                        <CustomContainer
                                            width='3.4' height='2.4'
                                            className='fixed-flex-shape'
                                        >
                                            <img 
                                                src={MasterCardIcon} 
                                                className='img-covered' 
                                                style={{objectFit: 'contain'}}  
                                            />
                                        </CustomContainer>
                                    }
                                    <input 
                                        placeholder="Enter card number"
                                        name='cardNumber'
                                        value={fundingInput.cardNumber}
                                        onChange={handleCardNumber}
                                        autoComplete="off"
                                        className='card-number'
                                        required
                                    />
                                </FlexRow>
                            </CustomContainer>
                            <FormGroup 
                                bottomMargin='0' width="30"
                                className="card_expiry-details"
                            >
                                <label>CVV</label>
                                <input 
                                    placeholder="Enter CVV"
                                    type='number'
                                    name='cvv'
                                    value={fundingInput.cvv}
                                    onChange={
                                        (e) => e.target.value.length <= 3 && 
                                            setFundingInput({...fundingInput, cvv: e.target.value})
                                    }
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FlexRow justifyContent='flex-end'>
                            <Button
                                width='5.8'
                                height='4' radius='0.8'
                                bottomMargin='1' hoverColor='#0D968F'
                                hoverBgColor='#fff' borderColor='#0D968F'
                            >
                                Pay
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </FlexColumn>
        </>
    )
}